export default __webpack_public_path__ + "static/media/warning--dangerous-crosswinds-right--g4.140e8377.png";